import { savedOrderDetailsProductListStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsProductList";
import { savedOrderListHeaderStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListHeader";
import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

savedOrderDetailsProductListStyles.wrapper = {
    css: css`
        border-top: none;
    `,
};

savedOrderListHeaderStyles.toggleFilterIcon = {
    src: "Filter",
    size: 24,
    css: css`
        color: ${getColor("primary")};
    `,
};
savedOrderListHeaderStyles.container = {
    gap: 8,
    css: css`
        padding-bottom: 10px;
    `,
};
savedOrderListTableStyles.orderDateCell = {
    css: css`
        font-weight: bold;
    `,
};
